<script lang="ts">
    import { fade } from 'svelte/transition';
    // import gui from '@src/assets/img/gui.webp';
    // import { gameState } from '../../store/index';
    // import { gameStates } from '@root/src/states/types';

    export let showAboveModals = false;

    /*
    const design = {
        width: 360,
        height: 768
    };
    let reverseDprTransform = `scale(1)`;
    window.addEventListener('resize', updateDPR);
    updateDPR();
    const translate = 'translate(-50%, 0)';
    function updateDPR() {
        const { clientWidth, clientHeight } = document.body;
        const { width, height } = design;
        if (clientWidth / clientHeight < 0.565) reverseDprTransform = `${translate} scale(${clientWidth / width})`;
        else reverseDprTransform = `${translate} scale(${clientHeight / height})`;
    }
    style="transform: {reverseDprTransform};"
    */
</script>

<div class="relative h-full">
    <div class="pointer-events-none fixed inset-0 h-full w-full">
        <div class="relative h-full w-full">
            <div
                class="absolute bottom-0 left-0 h-64 w-full bg-controls-gradient transition-all duration-500 desktop:h-52"
            />
        </div>
    </div>

    <div class="controls !z-9000" class:desktop:!z-9000={showAboveModals}>
        {#if !showAboveModals}
            <slot name="status" />
        {/if}

        <div
            class="controls__content adaptive-px relative flex h-[var(--controls-container-height)] w-full place-items-center items-center justify-center backdrop-blur-[1px]"
            transition:fade={{ duration: 200 }}
        >
            <slot />
        </div>

        <div class="bottom adaptive-px w-full">
            <slot name="footer" />
        </div>

        <!-- {#if $gameState === gameStates.game}
            <img class="bottom-center-gui-controls" src={gui} alt="background" />
        {/if} -->
    </div>
</div>

<style>
    .controls {
        position: fixed;
        bottom: 0;
        left: 50%;
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        flex-shrink: 0;
        flex-grow: 0;
        transform: translateX(-50%);
    }

    /* .bottom-center-gui-controls {
        width: 360px;
        height: 363px;
        position: absolute;
        bottom: 20px;
        z-index: 5;
        transform-origin: bottom center;
        pointer-events: none;
    } */
</style>
